export default "__VITE_ASSET__41582004__"